
















































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { MetaInfo } from 'vue-meta'
import { common } from '@/app/model/store/domain/const'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import PageTitle from '@/app/components/Common/PageTitle.vue'
import Loading from '@/app/components/Common/Loading.vue'
import Error409Modal from '@/app/components/Common/Error409Modal.vue'
import DeleteModal from '@/app/components/Common/DeleteModal.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'

import ExternalLinkCreateApi from '@/app/model/api/externalLinkCreateApi'
/* module */
import CommonClass from '@/app/module/common'
import ExternalLinkValidator from '@/app/module/validator/externalLinkValidator'
import VarietyListApi from '@/app/model/api/varietyListApi'
import DistrictListApi from '@/app/model/api/districtListApi'
import ExternalLinkDetailApi from '@/app/model/api/externalLinkDetailApi'
import ExternalLinkEditApi from '@/app/model/api/externalLinkEditApi'
import ExternalLinkDeleteApi from '@/app/model/api/externalLinkDeleteApi'

@Component({
  components: {
    CommonHeader,
    PageTitle,
    Loading,
    Error409Modal,
    DeleteModal,
    ErrorModal,
    ErrorInfo
  },
  metaInfo (this: ExternalLinkCreate): MetaInfo {
    return {
      title: this.setPageTitle
    }
  }
})
export default class ExternalLinkCreate extends Vue {
  private errorMessages: any = ''
  private alertText: string = ''
  private alertTitle: string = ''
  private externalLinkName: string = ''
  private externalLinkId: string = ''

  /* 表示非表示 */
  private showLoading: boolean = true
  private showServerErrorModal: boolean = false
  private showConfirmationModal: boolean = false
  private showError409Modal: boolean = false
  private show400ErrorMessage: boolean = false
  private createModeFlag: boolean = true

  private selectedVarietyOptions: any = [
    { text: 'すべて', value: 1 },
    { text: '選択', value: 0 }
  ]
  private selectedDistrictOptions: any = [
    { text: 'すべて', value: 1 },
    { text: '選択', value: 0 }
  ]
  private varietySelected: number = 1
  private districtSelected: number = 1
  private varietyData: any = []
  private districtData: any = []
  private selectedVarietyValue: any = []
  private selectedDistrictValue: any = []
  private externalLinkDetailData: any = {}
  private externalLinkTitle: string = ''
  private externalLinkHeaderTitle: string = ''

  private get setPageTitle () {
    let title = ''
    if (this.$route.path === '/external-link/create') {
      title = CommonClass.getServiceFunctionData().external_link.external_link_name + '追加 | ' + common.SYSTEM_NAME
    } else {
      title = CommonClass.getServiceFunctionData().external_link.external_link_name + '編集・削除 | ' + common.SYSTEM_NAME
    }
    return title
  }

  created () {
    window.scrollTo(0, 0)
    this.getVarieties()
    this.getDistricts()
    this.externalLinkTitle = CommonClass.getServiceFunctionData().external_link.external_link_name

    if (this.$route.path === '/external-link/create') {
      this.createModeFlag = true
      this.externalLinkHeaderTitle = this.externalLinkTitle + '追加'
    } else {
      this.createModeFlag = false
      this.externalLinkId = this.$route.params.external_link_id
      this.externalLinkHeaderTitle = this.externalLinkTitle + '編集・削除'
      this.getExternalLinkDetail(this.externalLinkId)
    }
  }

  private saveExternalLink () {
    if (this.validExternalLink()) {
      this.alertText = ''
      this.alertTitle = ''
      this.show400ErrorMessage = true
      window.scrollTo({ top: 0, behavior: 'auto' })
      return
    }

    if (this.createModeFlag) {
      this.createExternalLink()
    } else {
      this.updateExternalLink()
    }
  }

  private async createExternalLink () {
    const requestBody: any = {
      external_link_name: this.externalLinkName,
      variety: {
        is_all_varieties: this.varietySelected === 1,
        variety_options: ExternalLinkCreate.selectedVarietyContentsIfNeeded(this.varietySelected, this.selectedVarietyValue)
      },
      district: {
        is_all_districts: this.districtSelected === 1,
        district_options: ExternalLinkCreate.selectedDistrictContentsIfNeeded(this.districtSelected, this.selectedDistrictValue)
      }
    }

    const result = await ExternalLinkCreateApi.doExternalLinkCreate(requestBody)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: this.externalLinkTitle + '登録が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      const payload = result.getPayload()
      this.$router.push('/external-link/' + payload.external_link_id).catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'PUT', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
  }

  private static selectedVarietyContentsIfNeeded (isAll: number, data: any) {
    if (isAll === 1) {
      return []
    }

    const varietyContents = []
    for (const datum of data) {
      varietyContents.push({
        variety_id: datum
      })
    }
    return varietyContents
  }

  private static selectedDistrictContentsIfNeeded (isAll: number, data: any) {
    if (isAll === 1) {
      return []
    }

    const districtContents = []
    for (const datum of data) {
      districtContents.push({
        district_id: datum
      })
    }
    return districtContents
  }

  private validExternalLink (): boolean {
    let isValid = false
    if (ExternalLinkValidator.validRequireExternalLinkName('externalLinkNameErrorMessage', this.externalLinkName)) {
      isValid = true
    }

    if (ExternalLinkValidator.validMaxLengthExternalLinkName('externalLinkNameMaxLengthErrorMessage', this.externalLinkName)) {
      isValid = true
    }

    if (ExternalLinkValidator.validSelectedVarietyType('selectedVarietyTypeErrorMessage', this.varietySelected)) {
      isValid = true
    }

    if (ExternalLinkValidator.validSelectedDistrictType('selectedDistrictTypeErrorMessage', this.districtSelected)) {
      isValid = true
    }

    if (ExternalLinkValidator.validRequiredVariety('requiredVarietyErrorMessage', this.varietySelected, this.selectedVarietyValue)) {
      isValid = true
    }

    if (ExternalLinkValidator.validRequiredDistrict('requiredDistrictErrorMessage', this.districtSelected, this.selectedDistrictValue)) {
      isValid = true
    }

    this.errorMessages = ExternalLinkValidator.getErrorMessage()
    return isValid
  }

  private async updateExternalLink () {
    this.showLoading = true
    const requestBody: any = {
      external_link_name: this.externalLinkName,
      variety: {
        is_all_varieties: this.varietySelected === 1,
        variety_options: ExternalLinkCreate.selectedVarietyContentsIfNeeded(this.varietySelected, this.selectedVarietyValue)
      },
      district: {
        is_all_districts: this.districtSelected === 1,
        district_options: ExternalLinkCreate.selectedDistrictContentsIfNeeded(this.districtSelected, this.selectedDistrictValue)
      },
      time_stamp: this.externalLinkDetailData.time_stamp
    }

    const result = await ExternalLinkEditApi.doExternalLinkEdit(this.externalLinkId, requestBody)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: this.externalLinkTitle + '編集が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      this.showLoading = false
      this.$router.push('/external-link/' + this.$route.params.external_link_id).catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'PUT', 'text')
      this.showLoading = false
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
  }

  private getExternalLinkDetail (externalLinkId: string) {
    (async () => {
      const result = await ExternalLinkDetailApi.getDetail(externalLinkId)
      if (result.isOk()) {
        const payload = result.getPayload()
        this.externalLinkDetailData = payload
        this.externalLinkName = payload.external_link_name
        this.varietySelected = payload.variety.is_all_varieties ? 1 : 0
        this.selectedVarietyValue = this.choiceVarietyOptions(payload.variety.variety_options)
        this.districtSelected = payload.district.is_all_districts ? 1 : 0
        this.selectedDistrictValue = this.choiceDistrictOptions(payload.district.district_options)
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }

  private choiceVarietyOptions (data: any) {
    let ret = []

    for (const datum of data) {
      ret.push(datum.variety_id)
    }

    return ret
  }

  private choiceDistrictOptions (data: any) {
    let ret = []

    for (const datum of data) {
      ret.push(datum.district_id)
    }

    return ret
  }

  private doExternalLinkDelete () {
    (async () => {
      const result = await ExternalLinkDeleteApi.doExternalLinkDelete(this.externalLinkId)

      if (result.isOk()) {
        this.$store.commit('alertState/setAlertMessage', { type: 0, text: this.externalLinkTitle + 'を削除しました。' })
        this.$store.commit('alertState/setAlertFlag', true)
        this.$router.push('/external-link').catch(e => {})
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'DELETE', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.showConfirmationModal = false
    })()
  }

  private doCancel () {
    if (this.createModeFlag) {
      this.$router.push('/external-link').catch(e => {})
    } else {
      this.$router.push('/external-link/' + this.externalLinkId).catch(e => {})
    }
  }

  // 品種情報取得
  private getVarieties () {
    (async () => {
      const data = {
        word: '',
        order_name: 'variety_name',
        sort: true
      }

      const result = await VarietyListApi.getVarietyList(data)

      if (result.isOk()) {
        this.varietyData = result.getPayload().results
        if (result.getPayload().result_count === 0) {
          this.alertText = ''
          this.alertTitle = '品種が未登録です。品種を登録してから操作をしてください。'
          this.show400ErrorMessage = true
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
    })()
  }

  /* 地区取得 */
  private getDistricts () {
    (async () => {
      this.showLoading = true
      const data : any = {
        sortName: 'district_name',
        sort: 'asc',
        text: ''
      }

      const result = await DistrictListApi.getDistrictList(data)

      if (result.isOk()) {
        this.districtData = result.getPayload().results
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }
}
